import ArrowTopIcon from 'public/icons/arrow/top.svg'
import { FC } from 'react'

import { useHooks } from './hooks'

export const ScrollTopButton: FC = () => {
  const { scrollTop, isShowScroll } = useHooks()

  return (
    <div
      style={{
        display: 'flex',
        position: 'fixed',
        right: '32px',
        bottom: '16px',
        width: '60px',
        height: '60px',
        border: '1px solid #000',
        background: 'var(--ax-white, #FFF)',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        transition: 'opacity 0.4s',
        transitionDuration: '200ms',
        transitionProperty: 'all',
        zIndex: 5,
        opacity: isShowScroll ? 1 : 0,
      }}
      onClick={scrollTop}
    >
      <ArrowTopIcon width={24} height={24} />
    </div>
  )
}
